// ============================================================
// useIsMobile.js — Fase 7 (responsividade do painel)
//
// Hook simples: verdadeiro quando a largura da tela é estreita (celular
// ou tablet em retrato). Usado pra trocar layouts em grade (2-3 colunas
// fixas, que quebravam em tela estreita) por empilhado (1 coluna).
// ============================================================

import { useState, useEffect } from "react";

export default function useIsMobile(breakpoint = 640) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false
  );

  useEffect(() => {
    function aoRedimensionar() {
      setIsMobile(window.innerWidth < breakpoint);
    }
    window.addEventListener("resize", aoRedimensionar);
    return () => window.removeEventListener("resize", aoRedimensionar);
  }, [breakpoint]);

  return isMobile;
}
